import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import {
  redirectToSameWindowWithoutRefresh,
  getUrlWithCrid,
} from '../../../../../../../myaccount/src/utils/redirectWithCrId';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import * as S from './Header.styles';
import IconSelector from '@ibibo/icon-selector';
import {LOGIN_URL_NEW} from '../../../../../constants';
import {userCountrySelector} from '../../../../../store/selectors';

const Header = ({timeZone}) => {
  const history = useHistory();
  const userCountry = useSelector(userCountrySelector);

  const openLogin = () => {
    history.push(getUrlWithCrid(`${LOGIN_URL_NEW}`));
  };

  return (
    <S.HeaderMainWrap>
      <S.LogoInfoWrap>
        <S.HeaderLogoWrap>
          <IconSelector iconKey="partnerlogolight" props={{width: '15rem', height: '4rem'}} />
          <S.HeaderLoginLinkMob onClick={openLogin}>
            <IconSelector iconKey="loginLogo" />
            Login
          </S.HeaderLoginLinkMob>
          <S.HeaderLangSelectorMob>
            <LanguageSelector />
          </S.HeaderLangSelectorMob>
        </S.HeaderLogoWrap>
        <S.HeaderPartnerInfoWrap>
          <S.PartnerImgWrap>
            <img
              src="https://assets-gos3.goibibo.com/pavanputra_tours-1601365411.jpg"
              alt="pavanputra_tours"
            />
            <img
              src="https://assets-gos3.goibibo.com/pinnova_travels-1601365477.jpg"
              className="marginLM10"
              alt="pinnova_travels"
            />
            <img
              src="https://assets-gos3.goibibo.com/raj_travels-1601365337.jpg"
              className="marginLM10"
              alt="raj_travels"
            />
            <img
              src="https://assets-gos3.goibibo.com/sahu_tours-1601365372.jpg"
              className="marginLM10"
              alt="sahu_tours"
            />
          </S.PartnerImgWrap>
          <S.PartnerInfoTextWrap>
            <S.PartnerInfoText>
              Preferred by <span>55,000+ Travel Agents</span>
              {timeZone ? <span> in India</span> : <></>}{' '}
            </S.PartnerInfoText>
          </S.PartnerInfoTextWrap>
        </S.HeaderPartnerInfoWrap>
      </S.LogoInfoWrap>
      <S.HeaderLoginWrap>
        <S.HeaderLinkText href="#whymypartner">Why mypartner?</S.HeaderLinkText>
        <S.HeaderLinkText href="#advantage">Product highlights</S.HeaderLinkText>
        <S.HeaderLoginLink onClick={openLogin}>
          <IconSelector iconKey="loginLogo" />
          Login
        </S.HeaderLoginLink>
        {<LanguageSelector />}
      </S.HeaderLoginWrap>
    </S.HeaderMainWrap>
  );
};

export default Header;
